import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import { sponsorExportColumns } from '../../config/exportColumns/sponsorExportColumns'
import { appGetAllSponsor } from '../../store/sponsor'

function Sponsor() {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Sponsors and advertisements</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllSponsor({
										...params,
										limit: 100000,
										admin: true,
										sanstha: sansthaId || permissionOfSanstha,
										loading: false,
									}),
								)
							}
							columns={sponsorExportColumns}
							fileName="Sponsors"
							sheetName="Sponsor List"
							buttonText="Export Sponsors"
						/>
						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/sponsor/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Sponsor
						</button>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default Sponsor
